import React from 'react';
import { Row, Col } from 'react-bootstrap'; // JSS

import { Image, RichText } from '@sitecore-jss/sitecore-jss-react';
import MenuList from './MenuList';
import MediaQuery from 'react-responsive';

var SecondaryContainer = function SecondaryContainer(_ref) {
  var subItems = _ref.subItems,
      item = _ref.item,
      activeIndex = _ref.activeIndex,
      subContent = _ref.subContent,
      className = _ref.className;
  var shopLayout = (item === null || item === void 0 ? void 0 : item.url.indexOf("/shop")) !== -1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n            cb-menu__secondary-container\n            ".concat(Array.isArray(subItems) && typeof subItems[activeIndex] !== 'undefined' ? 'is-active' : '', "\n            ").concat(Array.isArray(subItems) && typeof subItems[activeIndex] === 'undefined' ? 'is-empty' : '', "\n            ").concat(className || '', "\n        ")
  }, item.children.map(function (_child, index) {
    var _subItems$index;

    return ((_subItems$index = subItems[index]) === null || _subItems$index === void 0 ? void 0 : _subItems$index.length) && activeIndex === index ? /*#__PURE__*/React.createElement("div", {
      className: "\n                    cb-menu__secondary-list\n                    ".concat(activeIndex === index ? 'is-active' : '', "\n                    "),
      role: "menu",
      id: "menu-".concat(index),
      "aria-expanded": false,
      key: index
    }, shopLayout ? /*#__PURE__*/React.createElement(ShopLayout, {
      selectedItem: subItems[index],
      shopLayout: shopLayout
    }) : /*#__PURE__*/React.createElement(DefaultLayout, {
      selectedItem: subItems[index],
      content: subContent[index]
    })) : '';
  }))), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n            cb-menu__secondary-container\n            ".concat(typeof subItems !== 'undefined' ? 'is-active' : '', "\n            ").concat(typeof subItems === 'undefined' ? 'is-empty' : '', "\n            ").concat(className || '', "\n        ")
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n              cb-menu__secondary-list\n              is-active\n              ",
    role: "menu",
    id: "menu-".concat(item.url),
    "aria-expanded": false,
    key: item.url
  }, shopLayout ? /*#__PURE__*/React.createElement(ShopLayout, {
    selectedItem: subItems,
    shopLayout: shopLayout
  }) : /*#__PURE__*/React.createElement(DefaultLayout, {
    selectedItem: subItems,
    content: subContent
  })))));
};

export default SecondaryContainer;

var ShopLayout = function ShopLayout(_ref2) {
  var selectedItem = _ref2.selectedItem,
      shopLayout = _ref2.shopLayout;
  return Array.isArray(selectedItem) && /*#__PURE__*/React.createElement(Row, {
    className: "cb-menu__shop-layout"
  }, selectedItem.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Col, {
      key: index
    }, /*#__PURE__*/React.createElement(MenuList, {
      item: item,
      shopLayout: shopLayout
    }));
  }));
};

var DefaultLayout = function DefaultLayout(_ref3) {
  var _ref3$selectedItem = _ref3.selectedItem,
      selectedItem = _ref3$selectedItem === void 0 ? [] : _ref3$selectedItem,
      _ref3$content = _ref3.content,
      content = _ref3$content === void 0 ? {} : _ref3$content;
  var navigationSubtitle = content.navigationSubtitle,
      navigationText = content.navigationText,
      navigationImage = content.navigationImage;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
    field: navigationSubtitle,
    tag: "h3",
    "aria-level": "3",
    className: "cb-menu__secondary-title"
  }), /*#__PURE__*/React.createElement(RichText, {
    field: navigationText,
    tag: "p",
    className: "cb-menu__secondary-text"
  }), selectedItem.map(function (item, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(MenuList, {
      item: item
    }));
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: "cb-menu__secondary-image"
  }, /*#__PURE__*/React.createElement(Image, {
    field: navigationImage
  }))));
};